export default "__VITE_ASSET__CD2uOiQw__"